import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const TreatmentOutcome = ({ moduleValues, setModuleValues, ...props }) => (
  <Grid item xs={props.xs ?? 12} lg={props.lg ?? 6}>
    <FormControl fullWidth>
      <InputLabel>Treatment Outcome</InputLabel>
      <Select
        label="Treatment Outcome"
        value={moduleValues?.['Treatment Outcome'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Treatment Outcome']: e.target.value,
          }))
        }
      >
        <MenuItem value="Improvement">Improvement</MenuItem>
        <MenuItem value="Symptoms Worsened">Symptoms Worsened</MenuItem>
        <MenuItem value="Complete Relief of Symptoms">
          Complete Relief of Symptoms
        </MenuItem>
        <MenuItem value="No Change">No Change</MenuItem>
        <MenuItem value="Patient Refused">Patient Refused</MenuItem>
        <MenuItem value="Adverse Reaction Noted">
          Adverse Reaction Noted
        </MenuItem>
        <MenuItem value="Unable to Administer Treatment">
          Unable to Administer Treatment
        </MenuItem>
        <MenuItem value="Other">Other</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default TreatmentOutcome
